export default "__VITE_ASSET__ChZJD94p__"